(function () {
  function $(id) {
    return document.getElementById(id);
  }

  function openPopup({ code, title, brand, affiliate, image }) {
    const popup = $("coupon-popup");
    if (!popup) return;

    const rmnTitle = $("rmnTitle");
    const rmnCode = $("rmnCode");
    const rmnLogo = $("rmnLogo");
    const rmnStoreLink = $("rmnStoreLink");
    const rmnCopy = $("rmnCopy");

    if (rmnTitle) rmnTitle.textContent = title || brand || "Coupon";
    if (rmnCode) rmnCode.textContent = code || "CODE";

    if (rmnLogo && image) {
      rmnLogo.style.backgroundImage = `url("${image}")`;
    }

    if (rmnStoreLink) {
      rmnStoreLink.textContent = brand || "store";
      rmnStoreLink.href = affiliate || "#";
    }

    if (rmnCopy && rmnCode) {
      rmnCopy.onclick = async function () {
        try {
          await navigator.clipboard.writeText(rmnCode.textContent || "");
          rmnCopy.textContent = "COPIED!";
          setTimeout(() => (rmnCopy.textContent = "COPY"), 1200);
        } catch {
          rmnCopy.textContent = "COPY";
        }
      };
    }

    // ✅ ONLY THIS CONTROLS VISIBILITY
    document.body.classList.add("popup-open");
  }

  function closePopup() {
    document.body.classList.remove("popup-open");
  }

  document.addEventListener("click", function (e) {
    const closeEl = e.target.closest("[data-close]");
    if (closeEl) {
      e.preventDefault();
      closePopup();
      return;
    }

    const btn = e.target.closest(".show-code-btn");
    if (!btn) return;

    btn.classList.add("revealed");
    
    const affiliate = btn.dataset.affiliate || "";
    if (affiliate) {
      window.open(affiliate, "_blank", "noopener,noreferrer");
    }

    openPopup({
      code: btn.dataset.code || "NO-CODE",
      title: btn.dataset.title || "",
      brand: btn.dataset.brand || "",
      affiliate,
      image: btn.dataset.image || ""
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePopup();
  });
})();
